import { ErrorMessageEn, ErrorMessageEs } from '../../../../constants/alerts';
import { errorHandler } from '../../../utils';
import {
  AddCandidateLanguageInput,
  AddCandidateLanguageOutput,
  CandidateLanguageBuilder,
} from '../candidate-language.types';

export const addCandidateLanguage = (builder: CandidateLanguageBuilder) =>
  builder.mutation<AddCandidateLanguageOutput, AddCandidateLanguageInput>({
    query: ({ languages }) => ({
      url: `/candidate-languages/save-range`,
      method: 'POST',
      body: {
        fileID: -1,
        languages: languages.map((language) => ({
          Id: language?.Id,
          LanguageName: language?.LanguageName?.val,
          LanguageProficiency: language?.LanguageProficiency?.val,
        })),
      },
    }),
    invalidatesTags: [{ type: 'candidateLanguages', id: 'LIST' }, 'Score'],
    transformErrorResponse: (error, meta, { lang }) => {
      errorHandler(
        '[addCandidateLanguage]',
        lang === 'es' ? ErrorMessageEs.InfoFail : ErrorMessageEn.InfoFail,
        error,
        true
      );
    },
  });
